<template>
  <div
    :class="[
      $style.base,
      {
        [$style.selected]: selected,
        [$style.smallScreen]: $screen === 's'
      }
    ]"
    @click="$emit('update:modelValue', modelValue)"
  >
    <div :class="$style.optionCard">
      <div :class="$style.label">
        <div :class="$style.labelCheck">
          <BaseIcon
            name="check"
            color="inverted"
            size="s"
          />
        </div>
        <div :class="$style.labelText">{{ label }}</div>
      </div>
      <img
        :src="image"
        :class="$style.image"
      >
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  modelValue: string | boolean;
  selected?: boolean;
  label: string;
  image: string;
}>();

defineEmits(['update:modelValue']);
</script>

<style
  lang="scss"
  module
>
.optionCard {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: relative;
  max-height: 100%;
  padding: $spacing $spacing 0;
  z-index: 1;
}
.base {
  position: relative;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  box-shadow: 0 0 0 0 var(--color-primary);
  transition: box-shadow 0.2s $easeOutBack;
  overflow: hidden;
  margin: auto;

  &.selected {
    font-weight: bold;
    box-shadow: 0 0 0 2px var(--color-primary);
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition:
      opacity 0.2s ease-out,
      transform 0.2s ease-out;
  }

  &:before {
    background: linear-gradient(
      45deg,
      transparent 0%,
      transparent 50%,
      rgb(222, 246, 241) 100%
    );
  }

  &:after {
    background: linear-gradient(
      45deg,
      rgb(195, 194, 232) 0%,
      transparent 50%,
      rgb(180, 236, 223) 100%
    );
  }

  &.selected {
    &:before {
      opacity: 0;
      transform: scale(2);
    }
  }

  &:not(.selected) {
    &:after {
      opacity: 0;
      transform: scale(2);
    }
  }
}

.image {
  height: 100%;
  max-height: 400px;
  max-width: 100%;
}

.label {
  position: relative;
  display: flex;
  align-items: center;
  margin: $spacing;
}

.labelCheck {
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  background-color: var(--color-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    opacity 0.2s $easeOutBack,
    transform 0.2s $easeOutBack;

  .base:not(.selected) & {
    opacity: 0;
    transform: scale(0.5);
  }

  .base.smallScreen & {
    display: none;
  }
}

.labelText {
  transition: transform 0.2s $easeOutBack;

  .base:not(.smallScreen).selected & {
    transform: translateX(25px);
  }
}
</style>
